/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Face } from '../../assets/themes/OPL/img/icons/Face.svg';

function ManageUsersButton({ ...props }) {
    const { classes, callback, callbackParam, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Face}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

ManageUsersButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default ManageUsersButton;
